import { render } from "./LesColloques.vue?vue&type=template&id=9e5dab00&scoped=true&ts=true"
import script from "./LesColloques.vue?vue&type=script&lang=ts"
export * from "./LesColloques.vue?vue&type=script&lang=ts"

import "./LesColloques.vue?vue&type=style&index=0&id=9e5dab00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e5dab00"]])

export default __exports__